import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { affiliateManagementService } from '../infra/affiliateManagementService';

interface ClearTierProtectionParams {
  projectId: string;
  affiliateId: string;
}

export function useClearTierProtection() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ projectId, affiliateId }: ClearTierProtectionParams) =>
      affiliateManagementService.clearTierProtection(projectId, affiliateId),
    onSuccess: (_data, variables) => {
      toast.success('Tier protection cleared');
      queryClient.invalidateQueries({
        queryKey: ['affiliate-management', 'detail', variables.projectId, variables.affiliateId],
      });
      queryClient.invalidateQueries({ queryKey: ['affiliate-management', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['project-affiliates'] });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to clear tier protection');
    },
  });

  return { clearTierProtection: mutateAsync, isLoading: isPending };
}
